import { z } from "zod";
import { zWorkShiftCommonSchema, zWorkShiftStatusSchema, } from "./workShift.common";
import { zDayjsSchema } from "../zDayjs";
export const zWorkShiftSchemaDom = zWorkShiftCommonSchema.extend({
    plannedStartTime: zDayjsSchema,
    plannedEndTime: zDayjsSchema,
    actualStartTime: zDayjsSchema.nullish(),
    actualEndTime: zDayjsSchema.nullish(),
});
// Тип для создания (без id, createdAt, updatedAt)
export const zWorkShiftCreateSchemaDom = zWorkShiftSchemaDom.omit({
    id: true,
});
// Типы для фильтрации
export const zWorkShiftFiltersSchema = z.object({
    idTechnicians: z.array(z.string()).optional(),
    status: z.array(zWorkShiftStatusSchema).optional(),
});
